import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card, Col, Row } from "antd";
import axios from "../../services/axios";
import { message } from "antd";
import moment from "moment";
import ReactLoading from "react-loading";
import { DatePicker } from "antd";
import exportFromJSON from "export-from-json";
import swal from "sweetalert";
import { useLocation } from "react-router-dom";
import { createGlobalStyle } from "styled-components";
import isConsultant from "../../services/isConsultant";
import { Select } from "antd";
import locations from "../../utils/api/locations";
import { checkPermission } from "../../utils/checkPermission";
import useRole from "../../hooks/useRole";

const { RangePicker } = DatePicker;
const { Option } = Select;

const DocumentRepots = (props) => {
  const location = useLocation();
  const [preferredLocation, setPreferredLocation] = useState([]);
  const [loc, setLoc] = useState("");
  const [defaultDate, setDefaultDate] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [load, setLoad] = useState(false);
  const [disabbled, setDisabbled] = useState(true);
  const flag = useRef(false);

  const [canViewDocumentReport, setCanViewDocumentReport] = useState(false);
  const [canDownloadDocumentReport, setCanDownloadDocumentReport] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const viewAllowed = await checkPermission(
        userRole,
        "document_report_module",
        "view_document_report"
      );
      const downloadAllowed = await checkPermission(
        userRole,
        "document_report_module",
        "download_document_report"
      );
      setCanViewDocumentReport(viewAllowed);
      setCanDownloadDocumentReport(downloadAllowed);
    } catch (err) {
      console.error("Error checking document report permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);

  useEffect(() => {
    if (flag.current) {
      loadCSV();
    }
    flag.current = true;
  }, [defaultDate, loc]);

  const [current, setCurrent] = useState(1);

  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const id = localStorage.getItem("user.id");

  const loadCSV = async () => {
    setLoad(true);
    await axios
      .get(
        `/candidateDocuments/documentDetails?StartDate=${
          defaultDate[0]
            ? defaultDate[0]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate[1]
            ? defaultDate[1]?._i
            : moment(new Date()).format("YYYY-MM-DD")
        }&location=${loc}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("user.token")}`
          }
        }
      )
      .then((res) => {
        const result = res.data;
        //  console.log("RES", res.data);
        const flattenArray = result?.map((ele) => {
          let flatObject = { ...ele };
          function flatten(obj, keyPrefix) {
            Object.keys(obj).forEach((key) => {
              if (typeof obj[key] === "object") {
                Object.assign(flatObject, obj[key]);
                delete flatObject[key];
              }
            });
          }
          flatten(ele, "");
          return flatObject;
        });
        const data = flattenArray;
        setCsvData(data);
        setLoad(false);
      })
      .catch((err) => {
        console.log(err);
        message.warning("Error Occured", 2);
        setLoad(false);
      });
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setCurrent(1);
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD")
      ]);
    } else {
      setCurrent(1);
      let startDate = moment(dateString[0], "YYYY-MM-DD");
      let endDate = moment(dateString[1], "YYYY-MM-DD");

      if (moment(endDate).isAfter(moment(startDate).add(60, "days"))) {
        swal({
          title: "You can not select data more than 60 days",
          icon: "error"
        });
      } else {
        setDefaultDate([startDate, endDate]);
        setDisabbled(false);
      }
    }
  };

  const onOk = (value) => {
    // console.log("onOk:", value);
  };

  useEffect(() => {
    locations().then((res) => {
      setPreferredLocation(res);
    });
  }, []);
  console.log(preferredLocation);
  //CSV DATA
  const exportType = "csv";
  let fileName = `DOCUMENT_REPORTS${moment(new Date()).format(
    "DD-MM-YYYY_HH:mm"
  )}`;

  // const downloadCSV = async() => {
  //   if(defaultDate.length === 0){
  //     swal({
  //       title: "Please select date range",
  //       icon: "error",
  //     })
  //   }
  //   else{
  //     const flattenArray =await csvData?.map(ele => {
  //       let flatObject = {...ele};
  //       function flatten(obj, keyPrefix) {
  //         Object.keys(obj).forEach(key => {
  //           if (typeof obj[key] === 'object') {
  //             Object.assign(flatObject, obj[key]);
  //             delete flatObject[key];
  //           }
  //         });
  //       }
  //       flatten(ele, '');
  //       return flatObject;
  //     });
  //     const data = flattenArray;
  //   setCurrent(1);
  //   exportFromJSON({ data, fileName, exportType });
  //   }
  // };

  const downloadCSV = async () => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };
    const data = flattenArray(csvData);
    setCurrent(1);
    exportFromJSON({ data, fileName, exportType });
  };

  const disabledDate = (current) => {
    // Disable future dates
    return current && current > moment().endOf("day");
  };

  return (
    <Dashboard title="Document Report">
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      {canViewDocumentReport ? (
        <Card>
          <div className="row ">
            <div className="col-md-6">
              <label htmlFor="candidate photo">
                Select Date
                <span style={{ color: "red" }}>*</span>
              </label>
              <RangePicker
                format="YYYY-MM-DD"
                style={{ width: "100%" }}
                // defaultValue={[moment(), moment()]}
                onChange={handleDate}
                onOk={onOk}
                disabledDate={disabledDate}
                placeholder={[
                  moment(new Date()).format("YYYY-MM-DD"),
                  moment(new Date()).format("YYYY-MM-DD")
                ]}
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="candidate photo">Select Location (optional) </label>
              <Select
                showSearch
                style={{ width: "100%", height: "37px" }}
                placeholder="Select Location"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option?.children
                      ?.toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0 ||
                    option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value) => setLoc(value)}>
                <Option value={""}>All</Option>
                {preferredLocation?.map((loc) => (
                  <Option value={loc?.locationName}>{loc?.locationName}</Option>
                ))}
              </Select>
            </div>
            {canDownloadDocumentReport && (
              <div className="col-md-3 align-items-end d-flex mt-4">
                <button
                  disabled={disabbled}
                  className={`btn ${
                    disabbled ? "btn-secondary" : "btn-primary"
                  } btn-block`}
                  onClick={downloadCSV}>
                  Download CSV
                </button>
              </div>
            )}
          </div>
        </Card>
      ) : (
        !load && <Card>You are not authorized to view this report.</Card>
      )}
    </Dashboard>
  );
};

export default DocumentRepots;
